import { api, throwApiError } from "../../api/api";

export type SlotRegistrationStatus =
  | "PENDENTE"
  | "APROVADO"
  | "REJEITADO"
  | "FALTOU"
  | "AUSENTE"
  | "CANCELADO"
  | string;

export type ExportRegistrationsCsvParams = {
  day?: string;
  dayFrom?: string;
  dayTo?: string;
  from?: string;
  to?: string;
  storeId?: string;
  status?: SlotRegistrationStatus;
  freelancerId?: string;
  cpf?: string;
  registrationId?: string;
  slotId?: string;
  decidedById?: string;
  hasPayment?: boolean;
  includeCanceledSlots?: boolean;
  freelancerName?: string;
};

const getFilenameFromDisposition = (disposition?: string) => {
  if (!disposition) return null;

  const match = disposition.match(/filename\*?=(?:UTF-8''|")?([^;"\n]+)"?/i);
  if (!match?.[1]) return null;

  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
};

export const downloadRegistrationsReportCsvApi = async (
  params: ExportRegistrationsCsvParams = {}
): Promise<{ blob: Blob; filename: string }> => {
  try {
    const { data, headers } = await api.get<Blob>("/reports/registrations", {
      params: {
        ...params,
        hasPayment:
          params.hasPayment === undefined ? undefined : String(params.hasPayment),
        includeCanceledSlots:
          params.includeCanceledSlots === undefined
            ? undefined
            : String(params.includeCanceledSlots),
      },
      responseType: "blob",
    });

    const filename =
      getFilenameFromDisposition(headers?.["content-disposition"]) ??
      `relatorio-de-agendamentos-${Date.now()}.csv`;

    return { blob: data, filename };
  } catch (error) {
    throwApiError(error, "Erro ao baixar relatório de agendamentos.");
    throw error;
  }
};

export const downloadRegistrationsReportPdfApi = async (
  params: ExportRegistrationsCsvParams = {}
): Promise<{ blob: Blob; filename: string }> => {
  try {
    const { data, headers } = await api.get<Blob>("/reports/registrations.pdf", {
      params: {
        ...params,
        hasPayment:
          params.hasPayment === undefined ? undefined : String(params.hasPayment),
        includeCanceledSlots:
          params.includeCanceledSlots === undefined
            ? undefined
            : String(params.includeCanceledSlots),
      },
      responseType: "blob",
    });

    const filename =
      getFilenameFromDisposition(headers?.["content-disposition"]) ??
      `relatorio-de-agendamentos-${Date.now()}.pdf`;

    return { blob: data, filename };
  } catch (error) {
    throwApiError(error, "Erro ao baixar relatório de agendamentos.");
    throw error;
  }
};

export const triggerBlobDownload = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
